<template>
  <div class="main">
    <filter-bar name="所属公司" :options="filterData.company_id" :is-all="company_id.length == 0"
      @on-clear="handleClearSearch('company_id')" class="mb-3">
      <template #item="{ option }">
        <v-checkbox :value="company_id" :val="option.id" @input="onFilterInput('company_id', $event)">{{ option.name
        }}</v-checkbox>
      </template>
    </filter-bar>
    <filter-bar name="吨位范围" :options="tonnageOptions" :is-all="tonnage.length == 0"
      @on-clear="handleClearSearch('tonnage')" class="mb-3">
      <template #item="{ option }">
        <v-checkbox :value="tonnage" :val="option.key" @input="onFilterInput('tonnage', $event)">{{ option.val
        }}</v-checkbox>
      </template>
    </filter-bar>
    <filter-bar name="船舶类型" :options="filterData.cruise_class" :is-all="class_id.length == 0"
      @on-clear="handleClearSearch('class_id')" class="mb-3">
      <template #item="{ option }">
        <v-checkbox :value="class_id" :val="option.key" @input="onFilterInput('class_id', $event)">{{ option.val
        }}</v-checkbox>
      </template>
    </filter-bar>
    <filter-bar name="首航时间" :options="firstFlightTimeOptions" :is-all="first_flight_time.length == 0"
      @on-clear="handleClearSearch('first_flight_time')" class="mb-3">
      <template #item="{ option }">
          <v-checkbox :value="first_flight_time" :val="option.key"
            @input="onFilterInput('first_flight_time', $event)">{{ option.val }}</v-checkbox>
        </template>
    </filter-bar>
    <filter-bar name="航行状态" :options="filterData.navistatus" :is-all="navistatus.length == 0"
      @on-clear="handleClearSearch('navistatus')" class="mb-3">
      <template #item="{ option }">
        <v-checkbox :value="navistatus" :val="option.key" @input="onFilterInput('navistatus', $event)">{{ option.val
        }}</v-checkbox>
      </template>
    </filter-bar>
    <div v-if="keyword" class="ml-[16px]">
      <span class="text-dark">关键字</span>
      <el-button @click="$emit('clearKeyword')" class="keyword text-white">{{ keyword }} <i class="el-icon-close"></i></el-button>
    </div>
  </div>
</template>

<script>
import { computed } from '@nuxtjs/composition-api';
import FilterBar from "@/components/product/filterBar";

export default {
  name: 'FrontPcCruiseListFilter',
  components: { FilterBar },
  props: {
    loading: Boolean,
    filterData: Object,
    company_id: Array,
    tonnage: Array,
    class_id: Array,
    first_flight_time: Array,
    navistatus: Array,
    keyword: String,
  },
  emits:['clearKeyword'],
  setup(props) {
    const tonnageOptions = computed(() => {
      return props.filterData.tonnage.map((item) => ({
        ...item,
        key: [item.min, item.max].join("-")
      }));
    });
    const firstFlightTimeOptions = computed(() => {
      return props.filterData.first_flight_time.map((item) => ({
        ...item,
        key: [item.min, item.max].join("-")
      }));
    });
    return { tonnageOptions, firstFlightTimeOptions }
  },

  methods: {
    handleClearSearch(key) {
      this.$emit(`update:${key}`, []);
      this.$nextTick(() => {
        this.$emit("on-filter-change");
      });
    },
    onFilterInput(key, value) {
      this.$emit(`update:${key}`, value)
      this.$nextTick(() => {
        this.$emit("on-filter-change")
      })
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-button {
  height: 24px;
  padding: 4px 8px 5px;
}
.main {
  padding: 24px 20px 90px 28px;
}
.keyword {
  margin-left: 28px;
  background-color: $color-black-2;
}
</style>
